<template>
  <div class="right-custom-menu">
    <template v-if="postByCategory">
    <div v-for="(section, index) in postByCategory"  :key="index"> 
      <template v-if="section.length"> 
        <p class="menu-title mb-4">{{ $t("overview") }}</p>
        <div v-for="(item, index) in section" :key="index"> 
          <p
          class="menu-content mb-4"
          :class="path.includes(item.Link) ? 'active' : ''"
          @click="handleClick(item.Link)"
        >
          {{ item.Title }}
        </p>
        </div>
      </template>
      <div v-if="index!=postByCategory.length-1" class="separator mb-4"></div>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["postData"],

  computed:{
    // seprating data by category 
    postByCategory(){
      if(!this.postData) return;
      let allCategory  = [...new Set(this.postData.map(item=>(item.PostTypeCode)))]
      let result = []
      allCategory.forEach(item=>{return result.push(this.postData.filter(_item=>_item.PostTypeCode ==  item))})
      return result
    }    
  },
  created() {
    this.$watch(
      () => this.$route.query?.post,
      () => {
        this.fetchData();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  data() {
    return {
      path: this.$route.query?.post
    };
  },
  methods: {
    handleClick(route) {
      this.$router.push( { path: '/guideline/detail', query: { post: route } }).catch(error=>{});
    },
    fetchData() {
      this.path = this.$route.query?.post
    },
  },
};
</script>

<style scoped>
.separator {
  background: #063;
  height: 1px;
}
.menu-content {
  color: var(--website-neutral-60, #18191a);
  /* Website & tablet/Menu */
  font-size: 14px;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  text-transform: uppercase;
  cursor: pointer;
}
.menu-content:hover {
  color: var(--website-neutral-60, #063);
  /* Website & tablet/Menu */
  font-size: 14px;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  text-transform: uppercase;
  cursor: pointer;
}
.active {
  color: var(--website-neutral-60, #063);
  font-weight: 600 !important;
}
.menu-title {
  color: var(--hover, #063);
  /* Maven Pro/24px - Semi Bold */
  font-family: "Maven Pro", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 36px */
  text-transform: uppercase;
}
.right-custom-menu {
  border-left: 2px solid var(--website-gray, #063);
  padding: 32px;
}
</style>
